import React from "react";
import PropTypes from "prop-types";

import ElementSwitcher from "../../ContentElements/ElementSwitcher";

const NewsDetailsLayout = ({ content, pageInfo }) => {
  const renderElements = () => {
    if (content.colPos0) {
      return (
        <ElementSwitcher contentElements={content.colPos0} breadcrumbs={pageInfo.breadcrumbs} />
      );
    }

    return <></>;
  };

  return renderElements();
};

NewsDetailsLayout.propTypes = {
  content: PropTypes.instanceOf(Object),
  pageInfo: PropTypes.instanceOf(Object),
};

export default NewsDetailsLayout;
